import {
  Component,
  Inject
} from '@angular/core';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AuthConfig } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
import { EntitlementService } from './shared/entitlement.service';
import { AppService } from './app.service';
import { environment } from 'src/environments/environment';
import {
  Router,
  Event, NavigationStart,
  ActivatedRoute,
  NavigationEnd
} from '@angular/router';

import { HttpService } from './shared/http.service';
import { IProduct } from './shared/models/profilelink.model';
import { CompanyService } from './company/company.service';
import { Labels } from './shared/labels';
import { DOCUMENT } from '@angular/common';
import { TabService } from './shared/tab.service';
import { IConfig } from './shared/config';
import { PrfAuthService } from './prf-auth.service';
import { IdleService } from './idle.service';
import { Store } from '@ngrx/store';
import * as AppActions from './store/actions/app.action';

declare function loadCustomerSelectionJS(): any;

export interface IProductList {
  id: number;
  categoryTitle: string;
  type: string;
  items: any;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title: string = Labels.app.name;
  currrWidth = window.innerWidth;
  hasAdminRole = false;
  menuLists: any[];
  footerList: any[];
  productLists: IProductList[] = [];
  isproducteligible = true;
  helpurl = 'https://iso.com';
  welomemessage: string;
  authConfig: AuthConfig = { waitForTokenInMsec: 10 };
  customerSuportUrl: string;
  ApplicationUrl: string;
  errorMessage: any;
  isAuthenticated = false;
  subscription: Subscription;
  isonetAuthmeUri: string;
  public isDashboard: string = 'none';
  public LoderVisible: string = 'none';
  public isAdmin: string = 'none';
  VendorName: string = '';
  dialogObj: any;
  sessiontitle = 'angular-idle-timeout';
  showLoadingIndicator = true;
  changePasswordLink: string = '#';
  manageProfileLink: string = '#';
  productNewsLink: string = '#';
  corporateHomeLink: string = '#';
  termsAndConditionsLink: string = '#';
  privacyAndPolicyLink: string = '#';
  contactUsLink: string = '#';
  configureMfaLink: string = '#';
  globalprfcustid: string;
  userISOProducts: IProduct[]; // megamenu data set
  allISOProducts: IProduct[]; // megamenu data set
  categoryISOProducts: Object;

  isJSLoaded: boolean = false;
  appConfig: IConfig;

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private router: Router,
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private entitlementService: EntitlementService,
    private AppService: AppService,
    private httpService: HttpService,
    private companyService: CompanyService,
    private tabService: TabService,
    private prfAuthService: PrfAuthService,
    private idleService: IdleService,
  ) {
    this.prfAuthService.initAuth()
    this.idleService.initIdle()
    this.router.events.subscribe((routerEvent: Event) => {
      this.checkRouterEvent(routerEvent);
    });
    this.setupredirect();
    localStorage.setItem("userid", this.httpService.getIsonetValue("userid"));

    var Cookiecstid = this.httpService.getIsonetValue("cstid");
    if (Cookiecstid) {
      this.hasAdminRole = this.AppService.setUserIdAndType(Cookiecstid);
      if (!this.hasAdminRole && Cookiecstid !== '' && Cookiecstid !== null) {
        this.companyService.setcustid(Cookiecstid);
      }
    }
    console.log('dddddddd');
    console.log(environment.enviroment_code);
    console.log('dddddddd');

    if (environment.enviroment_code == 'D') {
      this.companyService.setcustid('8337');



      //Customer
      localStorage.setItem('userid', 'max');
      localStorage.setItem('groupcode', '0057');
      localStorage.setItem('groupname', 'Test');

    }

    this.welomemessage = 'Connecting to ISONet....';


    // sets an idle timeout of 5 seconds, for testing purposes.


    this.allISOProducts = [];
    this.userISOProducts = [];
    this.categoryISOProducts = {};


    const userId: string = httpService.getIsonetValue('userid');
    const ticket: string = this.prfAuthService.accessToken();

    this.AppService.getAllProducts().subscribe((data) => {
      // populate category products
      if (data['categories']) {
        data['categories'].forEach((c) => {
          this.categoryISOProducts[c['title']] = c['products'];
        });
      }

      for (const key in this.categoryISOProducts) {
        const index1 = this.categoryISOProducts[key].findIndex(
          (d) => d.title == 'Electronic Participation Reports'
        );
        if (index1 > -1) {
          this.categoryISOProducts[key].splice(index1, 1);
        }
        const index2 = this.categoryISOProducts[key].findIndex(
          (d) => d.title == 'Stat Agent Visualizer & Reports'
        );
        if (index2 > -1) {
          this.categoryISOProducts[key].splice(index2, 1);
        }
        const index3 = this.categoryISOProducts[key].findIndex(
          (d) => d.title == 'Strategic Alliances Services'
        );
        if (index3 > -1) {
          this.categoryISOProducts[key].splice(index3, 1);
        }
      }

      // populate all products
      if (data['products']) {
        data['products'].forEach((p) => {
          if (
            p['title'] != 'Electronic Participation Reports' &&
            p['title'] != 'Stat Agent Visualizer & Reports' &&
            p['title'] != 'Strategic Alliances Services'
          ) {
            const item: IProduct = {
              id: p['id'],
              title: p['title'],
              url: p['url'],
              isEligible: p['isEligible'],
            };
            this.allISOProducts.push(item);
          }
        });
      }

      this.AppService.getUserProducts(userId, ticket).subscribe({
        next: (_userProducts) => {
          // populate user products
          this.userISOProducts = _userProducts;
          if (_userProducts) {
            _userProducts.forEach((p) => {
              const item: IProduct = {
                id: p['id'],
                title: p['title'],
                url: p['url'],
                isEligible: p['isEligible'],
              };
              this.userISOProducts.push(item);

              // reset eligible products in all products
              const index = this.allISOProducts.findIndex((element) => {
                return element.title === p.title;
              });
              if (index > -1) {
                this.allISOProducts[index].isEligible = true;
              }
              // reset eligible products in category products
              // tslint:disable-next-line: forin
              for (const key in this.categoryISOProducts) {
                const i = this.categoryISOProducts[key].findIndex((element) => {
                  return element.title === p.title;
                });
                if (i > -1) {
                  this.categoryISOProducts[key][i].isEligible = true;
                }
              }
            });
          }
        },
        error: (error) => (this.errorMessage = <any>error)
      });

      this.productLists.push(
        {
          id: 1,
          categoryTitle: 'My Products',
          type: 'head',
          items: this.userISOProducts,
        },
        {
          id: 2,
          categoryTitle: 'Full List of Products',
          type: 'head',
          items: this.allISOProducts,
        }
      );
    });

    this.AppService.getAllUserProfileLinks().subscribe({
      next: (_headerLinks) => {
        if (_headerLinks) {
          _headerLinks.forEach((up) => {
            if (up.linkFor === 'Change Password') {
              this.changePasswordLink = up.url;
            }
            if (up.linkFor === 'Manage Profile') {
              this.manageProfileLink = up.url;
            }
            if (up.linkFor === 'Manage Your ISOnet Product News') {
              this.productNewsLink = up.url;
            }
            if (up.linkFor === 'Verisk Corporate Home') {
              this.corporateHomeLink = up.url;
            }
            if (up.linkFor === 'Terms and Conditions') {
              this.termsAndConditionsLink = up.url;
            }
            if (up.linkFor === 'Privacy and Security Policy') {
              this.privacyAndPolicyLink = up.url;
            }
            if (up.linkFor === 'Contact Us') {
              this.contactUsLink = up.url;
            }
            if (up.linkFor === 'Configure MFA') {
              this.configureMfaLink = up.url;
            }
            this.fillMenuList();
            this.fillFooterList();
          });
        }
      },
      error: (error) => (this.errorMessage = <any>error)
    });

    this.AppService.getUserEligibleproductv2(
      environment.ProductIdAlias,
      ticket
    ).subscribe((iseligible) => {
      if (iseligible) {
        this.AppService.isProductEligible.next(true);
      } else {
        this.AppService.isProductEligible.next(false);
      }
    });
  }


  private setupredirect() {
    if (window.location.href.includes('/redirecttovalidationsummary')) {
      sessionStorage.setItem(
        'redirectToValidationSummaryUrl',
        window.location.href
      );
    }
    else if (window.location.href.includes('/redirect')) {
      sessionStorage.setItem(
        'redirect',
        window.location.href
      );
    }
  }



  ngOnInit(): void {
    this.entitlementService.getLoginStatus().pipe(distinctUntilChanged()).subscribe(status => {
      this.isAuthenticated = status;
      if (status && !this.isJSLoaded) {
        this.loadJSScript().onload = () => {
          this.isJSLoaded = true;
          loadCustomerSelectionJS();
        };
      }
    })
    this.AppService.title.subscribe((updatedTitle) => {
      this.title = updatedTitle;
    });
    this.AppService.display.subscribe((display) => {
      this.isDashboard = display;
    });

    this.AppService.vendorname.subscribe((vendorname) => {
      this.VendorName = 'Vendor: ' + vendorname;
    });
    this.AppService.admin.subscribe((admin) => {
      this.isAdmin = admin;
    });

    this.AppService.isProductEligible.subscribe((isEligible) => {
      this.isproducteligible = isEligible;
    });

    this.tabService.switchChange$().subscribe((isActive) => {
      if (isActive) {
        const ticket = this.prfAuthService.accessToken();
        if (!ticket && environment.enviroment_code != 'D') {
          this.httpService.logout();
        }
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const prfyear = this.getRouteParam('prfyear');
      const prfnumber = this.getRouteParam('prfnumber');

      if (prfyear && prfnumber) {
        const groupcode = prfnumber.substring(0, 4);
        this.store.dispatch(AppActions.loadCompanyInfo({
          groupcode: groupcode,
          prfnumber: prfnumber,
          prfyear: parseInt(prfyear, 10)
        }));
      } else if (prfyear) {
        this.store.dispatch(AppActions.setCompanyInfo({
          prfname: '',
          groupcode: '',
          prfnumber: '',
          prfyear: parseInt(prfyear, 10)
        }));
      }
    });
  }
  //Adobe Launch Code
  public loadScript() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = environment.adobeLaunchCode;
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }

  homeClick() {
    this.AppService.setTitle('DashBoard');
  }





  checkRouterEvent(routerEvent: Event): void {
    if (routerEvent instanceof NavigationStart) {
      var userId: string = this.httpService.getIsonetValue('userid');
      var customerid: string = this.httpService.getIsonetValue('cstid');
      var customername: string = this.httpService.getIsonetValue('customername');
      var prfnumber: string = this.getRouteParam('prfnumber') || '';

      var digitalData = {
        page: {
          pageInfo: {
            pageID: window.location.hostname + routerEvent.url,
            URL: window.location.hostname,
            path: window.location.pathname,
            subdomain: '',
            product: 'Premium Report Form',
            prf_numb: prfnumber, // PRF number when on one
            cust_type: this.hasAdminRole ? 'admin' : 'normal user', // admin or normal user
          },
          user: {
            username: userId,
            customerid: customerid,
            customername: customername,
          },
        },
      };
      window['digitalData'] = digitalData;

      var evt = new CustomEvent('event-view-start');
      document.body.dispatchEvent(evt);
    }
    this.prfAuthService.checkRouterEvent(routerEvent);
    this.errorMessage = "";
  }





  fillMenuList() {
    this.menuLists = [];
    this.menuLists = [
      {
        id: 1,
        title: 'Change Password',
        url: this.changePasswordLink,
      },
      {
        id: 2,
        title: 'Manage Profile',
        url: this.manageProfileLink,
      },
      {
        id: 3,
        title: 'Manage Your ISOnet Product  News',
        url: this.productNewsLink,
      },
      {
        id: 17,
        title: 'Configure MFA',
        url: this.configureMfaLink,
      },
    ];
  }

  fillFooterList() {
    this.footerList = [
      {
        id: 1,
        title: 'Verisk Corporate Home',
        url: this.corporateHomeLink,
      },
      {
        id: 1,
        title: 'Terms and Conditions',
        url: this.termsAndConditionsLink,
      },
      {
        id: 1,
        title: 'Privacy and Security Policy',
        url: this.privacyAndPolicyLink,
      },
      {
        id: 1,
        title: 'Contact Us',
        url: this.contactUsLink,
      },
    ];
  }

  getCookie(name: string) {
    return sessionStorage.getItem(name);
  }

  private getRouteParam(paramName: string): string | null {
    let route = this.route;
    while (route) {
      if (route.snapshot.paramMap.has(paramName)) {
        return route.snapshot.paramMap.get(paramName);
      }
      route = route.firstChild;
    }
    return null;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  //js loader for isonet okta integration
  public loadJSScript(): HTMLScriptElement {
    this.loadScript();
    const script = document.createElement('script');
    script.src = environment.OKTA_INTEGRATION_JS;
    script.async = true;
    document.head.appendChild(script);
    return script;
  }
}
